const base_url = 'https://backendos.toon-flix.com'
export {base_url}


// const base_url = 'http://192.168.1.13:8810'
// export {base_url}